import dayjs from 'dayjs'

import '../../../../ts-utils/date-utils'
import { resolveAssetUrl } from '../../../../utils/assetUrl'
import { CARD_STATS, MISSING_STAT } from '../constants'
import type { GameStat, RecentGameCardModel, StatsRole } from '../types'
import { buildGameResult, formatMatchup, getOpponentName } from './gameResult'
import { getGameStatValue } from './statValues'

export const formatGameDate = (
  iso: string,
  timezone: string,
  pattern: string
): string => dayjs(iso).tz(timezone).format(pattern)

export const buildRecentGameCard = (
  g: GameStat,
  role: StatsRole,
  timezone: string
): RecentGameCardModel => ({
  gameId: g.game.id,
  date: formatGameDate(g.game.starts_at, timezone, 'MMM D, YYYY'),
  result: buildGameResult(g),
  matchup: formatMatchup(g),
  opponentName: getOpponentName(g),
  opponentAbbr:
    g.opponent?.abbreviation ?? getOpponentName(g).slice(0, 3).toUpperCase(),
  opponentLogo: resolveAssetUrl(g.opponent?.image),
  stats: CARD_STATS[role].map((abbr) => ({
    abbr,
    value: getGameStatValue(g.stats, abbr) ?? MISSING_STAT,
  })),
})
